import { useRef } from 'react';
import * as S from './LandmarksCarousel.styles';
import { Container } from '@/common/ui/containers/Container';
import { useCarousel } from '@/common/app/hooks/useCarousel';
import { TLandmarksShort } from '@/screens/LandmarkMainPage/domain/Landmarks.domain';
import Link from 'next/link';
import { CardImage } from '@/screens/CommonPage/ui/commonPage/CardItem/cardItem/CardImage/CardImage';
import { URL } from '@/common/app/utils/urlsUtils';

export type LandmarksCarouselProps = {
    landmarks: TLandmarksShort;
    stateCode: string;
    destinationSlug: string;
    destinationName: string;
    title: string;
};

export const LandmarksCarouselContainer = ({
    landmarks,
    stateCode,
    destinationSlug,
    destinationName,
    title,
}: LandmarksCarouselProps) => {
    const mainTitle = title || '';
    const scrollRef = useRef<HTMLDivElement>(null);

    const {
        prevBtnIsActive,
        nextBtnIsActive,
        onClickHandler,
        onScrollHandler,
        DIRECTION,
        withDot,
    } = useCarousel({ ref: scrollRef, countItems: landmarks.length ? landmarks.length : 3 });

    if (!landmarks.length) {
        return <></>;
    }

    const basePath = `/destination/${stateCode}/${destinationSlug}/landmarks/`.toLowerCase();
    const location = `${destinationName}, ${stateCode}`;

    return (
        <S.Wrapper>
            <Container>
                <S.Block data-test-id="Widget-attraction" className="container">
                    <S.Header>
                        <S.LeftPartHeader>
                            <S.Title>{mainTitle}</S.Title>
                        </S.LeftPartHeader>
                    </S.Header>
                    <S.CarouselWraper>
                        <S.Gallery ref={scrollRef} onScroll={onScrollHandler}>
                            <S.InnerContainer className="carousel-container">
                                {landmarks.map(({ name, id, slug }) => {
                                    return (
                                        <Link
                                            href={`${basePath + slug.toLowerCase()}/`}
                                            key={id}
                                            passHref
                                        >
                                            <S.Container className="card">
                                                <CardImage
                                                    imageSrc={`${URL.image}/landmark/${id}/700x600/${slug}.jpg`}
                                                    title={name}
                                                />
                                                <S.Content>
                                                    <S.Name>{name}</S.Name>
                                                    <S.Location>
                                                        <S.LocationImg />
                                                        <S.LocationCity>{location}</S.LocationCity>
                                                    </S.Location>
                                                </S.Content>
                                            </S.Container>
                                        </Link>
                                    );
                                })}
                            </S.InnerContainer>
                        </S.Gallery>
                        {prevBtnIsActive && withDot && (
                            <S.CenterLeftArrow
                                onClick={() => onClickHandler(DIRECTION.prev)}
                                disabled={false}
                            />
                        )}
                        {nextBtnIsActive && withDot && (
                            <S.CenterRightArrow
                                onClick={() => onClickHandler(DIRECTION.next)}
                                disabled={false}
                            />
                        )}
                    </S.CarouselWraper>
                </S.Block>
            </Container>
        </S.Wrapper>
    );
};

export const LandmarksCarousel = LandmarksCarouselContainer;
